import { render } from "./ViewerForms.vue?vue&type=template&id=50c9bfb9"
import script from "./ViewerForms.vue?vue&type=script&lang=js"
export * from "./ViewerForms.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__